import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { errorLog } from "../../../logger";
import { getManuallyTrackedAccountsKeyMaker } from "../../Accounts/hooks/useGetManuallyTrackedAccounts";
import { genIdempotencyKey } from "../../utils/genIdempotencyKey";
import deleteManualAccount from "../requests/deleteManualAccount";
import { externalAccountsKeyMaker } from "./useExternalAccounts";
import { getAllExternalAccountsKeyMaker } from "./useGetExternalAccounts";
const IDEMPOTENCY_DESCRIPTOR = "delete-manual-account";
export default function useDeleteManualAccount(clientId, config) {
    const queryClient = useQueryClient();
    const [idempotencyKey, setIdempotencyKey] = useState(genIdempotencyKey(IDEMPOTENCY_DESCRIPTOR));
    return useMutation(async (accountId) => {
        if (config === null) {
            throw new Error("no auth");
        }
        // Include accountId in the idempotency key for better uniqueness
        const accountSpecificIdempotencyKey = `${idempotencyKey}-${accountId}`;
        return deleteManualAccount(accountId, clientId, accountSpecificIdempotencyKey, config);
    }, {
        onSuccess: () => {
            // Remove the queries that contain the manual account since it's being deleted
            queryClient.removeQueries({
                queryKey: externalAccountsKeyMaker(),
            });
            queryClient.removeQueries({
                queryKey: getAllExternalAccountsKeyMaker(clientId),
            });
            queryClient.removeQueries({
                queryKey: getManuallyTrackedAccountsKeyMaker(clientId),
            });
        },
        onError: (err) => {
            if (err instanceof Error) {
                errorLog("[useDeleteManualAccount]", err.message);
            }
            else {
                errorLog("[useDeleteManualAccount]", String(err));
            }
        },
        onSettled: () => {
            setIdempotencyKey(genIdempotencyKey(IDEMPOTENCY_DESCRIPTOR));
        },
    });
}
//# sourceMappingURL=useDeleteManualAccount.js.map